import { useQuery } from "@tanstack/react-query";
import { fetchRecipes } from "../lib/api";
import type { ListRecipesParams } from "../types";

export function useRecipes(params?: ListRecipesParams) {
  return useQuery({
    queryKey: ["recipes", params],
    queryFn: () => fetchRecipes(params),
    staleTime: 1000 * 60 * 5,
  });
}
